import {
  View,
  Text,
  StyleSheet,
  Animated,
  TouchableOpacity,
} from "react-native";
import React, { useRef, useState, useEffect } from "react";
import { shadowSm, primary } from "../../colors";
import MyText from "../custom/MyText";
import { Fontisto, Entypo } from "@expo/vector-icons";

export default function MyFaq(props) {
  const animation = useRef(new Animated.Value(50)).current;
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(false);

  useEffect(() => {
    if (open) {
      Animated.timing(animation, {
        toValue: 50 + height,
        useNativeDriver: false,
        duration: 500,
      }).start();
    } else {
      Animated.timing(animation, {
        toValue: 50,
        useNativeDriver: false,
        duration: 500,
      }).start();
    }
  }, [open]);
  const iconRotate = animation.interpolate({
    inputRange: [50, height + 50],
    outputRange: ["0deg", "180deg"],
  });
  return (
    <Animated.View style={[styles.container, { height: animation }]}>
      <TouchableOpacity onPress={() => setOpen(!open)} style={styles.header}>
        <Fontisto name="question" size={20} color={primary} />
        <MyText style={{ marginHorizontal: 5 }}>{props.question}</MyText>
        <View style={{ flex: 1 }}></View>
        <Animated.View style={{ transform: [{ rotate: iconRotate }] }}>
          <Entypo name="chevron-down" size={24} color={primary} />
        </Animated.View>
      </TouchableOpacity>
      <View style={{ height: 500, padding: 10 }}>
        <View
          onLayout={(event) => {
            let { x, y, width, height } = event.nativeEvent.layout;
            setHeight(height + 10);
          }}
        >
          {props.children}
        </View>
      </View>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    width: "90%",
    overflow: "hidden",
    ...shadowSm,
  },
  header: {
    height: 50,
    padding: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});
